import { useStore } from '../../utils/store';
import React, {
  useEffect,
  useRef,
  useState,
  useImperativeHandle,
  forwardRef,
} from 'react';
import HttpService from '../../services/HttpService';
import Constants from '../../utils/constants';
import FormFieldData from '../../Models/FormFieldData';

import {
  Box,
  CircularProgress,
  Divider,
  Stack,
  Typography,
} from '@mui/material';
import tabStore from './tabStore';
import CommonForm from '../../components/form/CommonForm';
import AlertMessageComponent from '../../components/AlertMessageComponent';
import { useCrewCalender } from './StoreCrewCalendar';
import { ToastMessage } from '../../Models/ToastMessage';
import ShiftSaveButtons from './parts/SaveButtons';
import { useGoogleMap } from '../../components/GoogleMapContext';
import GoogleMapModal from '../../components/GoogleMapModal';
import { handleErrorMessage } from '../../utils/storageUtil';
interface ShiftDetailsFormProps {
  projectList: any[];
  crewList: any[];
  crewId: number;
  currentRecord: any;
  saveSuccess: (data: any) => void;
  goBack: () => void;
}
export type DetailRef = {
  handleSave: (type: any) => void;
};

const ShiftDetailsForm = forwardRef<DetailRef, ShiftDetailsFormProps>(
  (
    { projectList, crewList, crewId, currentRecord, saveSuccess, goBack },
    ref
  ) => {
    const { getAdmin } = useStore();
    const hasInitialized = useRef(false);
    const { selectedShiftDate, setSuccessMessage, setOpenSuccess } =
      useCrewCalender();
    const [httpError, setHttpError] = useState<ToastMessage>({
      message: '',
      errorColor: 'success',
      open: false,
    });

    const [loading, setLoading] = useState(false);
    const [processing, setProcessing] = useState<boolean>(false);
    const [publishing, setPublishing] = useState<boolean>(false);
    const [quoteDetails, setQuoteDetails] = useState<any>(null);

    useImperativeHandle(ref, () => ({
      handleSave,
    }));
    type shiftDetailsFormObj = {
      [key: string]: {
        required: boolean;
        value: any;
      };
    };
    const [shiftDetailsForm, setShiftDetailsForm] =
      useState<shiftDetailsFormObj>({
        id: { required: false, value: null },
        date: {
          required: true,
          value: selectedShiftDate
            ? selectedShiftDate.date
              ? selectedShiftDate.date
              : new Date()
            : new Date(),
        },
        crewId: { required: true, value: crewId },
        projectInternalId: { required: true, value: 0 },
        siteContactName: { required: true, value: '' },
        siteContactNumber: { required: true, value: '' },
        shiftStatusId: { required: false, value: '' },
      });
    const { siteAddress, setSiteAddress, isChoosing } = useGoogleMap();

    const handleshiftDetailsFormChange = (
      e: React.ChangeEvent<
        HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
      >
    ) => {
      const { name, value } = e.target;
      tabStore.updateField('tab1Field', value);
      setShiftDetailsForm((prev) => ({
        ...prev,
        [name]: { required: prev[name].required, value: value },
      }));
      if (name === 'projectInternalId') {
        const projectData = projectList.find(
          (item) => parseInt(item.id) === parseInt(value)
        );
        if (projectData) {
          fetchQuoteDetails(projectData.quoteId);
        }
      }
    };

    const clearForm = () => {};
    const isValidForm = () => {
      let isValid: boolean = true;
      if (
        !shiftDetailsForm.projectInternalId.value?.toString().trim() ||
        !shiftDetailsForm.crewId.value?.toString().trim() ||
        !shiftDetailsForm.date.value?.toString().trim() ||
        !shiftDetailsForm.siteContactNumber.value?.toString().trim()
      ) {
        isValid = false;
      }
      return isValid;
    };
    const handleSave = async (type: number) => {
      if (!isValidForm()) {
        setHttpError({
          errorColor: 'error',
          message: 'All fields are required.',
          open: true,
        });
        return false;
      }
      tabStore.updateField('tab1Field', '');

      const shiftReq: any = {
        shiftId: shiftDetailsForm.id.value,
        projectInternalId: shiftDetailsForm.projectInternalId.value,
        crewId: shiftDetailsForm.crewId.value,
        date: shiftDetailsForm.date.value,
        siteAddress,
        siteContactName: shiftDetailsForm.siteContactName.value,
        siteContactNumber: shiftDetailsForm.siteContactNumber.value,
        shiftStatusId: type,
      };
      if (type === 0 || 3) {
        setProcessing(true);
      } else {
        setPublishing(true);
      }

      const endpoint = Constants.apiURL + Constants.shiftURL;
      if (currentRecord) {
        shiftReq['id'] = currentRecord.id;
      }
      let response: any;

      try {
        if (currentRecord) {
          response = await HttpService.put(endpoint, shiftReq, {
            headers: { Authorization: `Bearer ${getAdmin()}` },
          });
        } else {
          response = await HttpService.post(endpoint, shiftReq, {
            headers: { Authorization: `Bearer ${getAdmin()}` },
          });
        }

        if (response.success) {
          saveSuccess(response.data);
          clearForm();
          setSuccessMessage(type === 0 ? 'Saved' : 'Saved successfully');
          setOpenSuccess(true);
        }
        if (type === 1 || 4) {
          goBack();
        }
        return true;
      } catch (error: any) {
        let message: any = handleErrorMessage(error);

        setHttpError({
          errorColor: 'error',
          message: message,
          open: true,
        });
        return false;
      } finally {
        setProcessing(false);
        setPublishing(false);
        return true;
      }
    };

    const handleRowClick = (record: any) => {
      console.log('In record');
      setShiftDetailsForm({
        id: { required: false, value: record.shiftId },
        date: { required: true, value: record.date },
        crewId: { required: true, value: record.crewId },
        projectInternalId: { required: true, value: record.projectInternalId },
        siteContactName: { required: true, value: record.siteContactName },
        siteContactNumber: { required: true, value: record.siteContactNumber },
        shiftStatusId: { required: false, value: record.shiftStatusId },
      });

      setSiteAddress(record.siteAddress);
    };

    function handleCloseAlert() {
      setHttpError((prev) => {
        return {
          ...prev,
          open: false,
        };
      });
    }
    const handleshiftDetailsFormDate = (value: any) => {
      const dateValue =
        value.year() + '-' + (value.month() + 1) + '-' + value.date();
      tabStore.updateField('tab1Field', dateValue);
      setShiftDetailsForm((prev: any) => {
        return {
          ...prev,
          date: {
            required: prev['date'].required,
            value: dateValue,
          },
        };
      });
    };

    const phoneRegex =
      /^(\+?\(61\)|\(\+?61\)|\+?61|\(0[1-9]\)|0[1-9])?( ?-?[0-9]){7,9}$/;

    const formFields: FormFieldData[] = [
      {
        name: 'date',
        label: 'Shift Date',
        value: shiftDetailsForm.date.value,
        onChange: (e: any) => {
          console.log(e);
          handleshiftDetailsFormDate(e);
        },
        isRequired: shiftDetailsForm.date.required,
        size: 12,
        disabled: currentRecord
          ? currentRecord.shiftStatusId > 0
            ? true
            : false
          : false,
        type: 'datepicker',
        validationRules: [
          (value) => (!value ? 'Customer name is required' : ''),
        ],
      },
      {
        name: 'projectInternalId',
        label: 'Project Name',
        value: shiftDetailsForm.projectInternalId.value,
        onChange: handleshiftDetailsFormChange,
        isRequired: shiftDetailsForm.projectInternalId.required,
        size: 6,
        type: 'selectField',
        disabled: currentRecord
          ? currentRecord.shiftStatusId > 0
            ? true
            : false
          : false,
        options: projectList,
        validationRules: [(value) => (!value ? 'Project  is required' : '')],
      },
      {
        name: 'crewId',
        label: 'Allocated Crew',
        value: shiftDetailsForm.crewId.value,
        onChange: handleshiftDetailsFormChange,
        isRequired: shiftDetailsForm.crewId.required,
        disabled: currentRecord
          ? currentRecord.shiftStatusId > 0
            ? true
            : false
          : false,
        size: 6,
        type: 'selectField',
        options: crewList,
        validationRules: [(value) => (!value ? 'Crew is required' : '')],
      },
      {
        name: 'siteAddress',
        label: 'Site Address',
        value: siteAddress,
        onChange: (e: any) => {
          console.log(e);
          setSiteAddress(e.target.value);
        },
        isRequired: true,
        size: 12,
        disabled: currentRecord
          ? currentRecord.shiftStatusId > 0
            ? true
            : false
          : false,
        type: 'GoogleMapTextField',
        validationRules: [
          (value) => (!value ? 'Site Address is required' : ''),
        ],
      },
      {
        name: 'custom',
        label: '',
        value: 'custom',
        onChange: handleshiftDetailsFormChange,
        isRequired: false,
        size: 12,

        type: 'custom',
        customComponent: (
          <Typography component={'h6'} sx={{ fontWeight: 'bold' }}>
            Contact
          </Typography>
        ),
        validationRules: [],
      },
      {
        name: 'siteContactName',
        label: 'Name',
        value: shiftDetailsForm.siteContactName.value,
        onChange: handleshiftDetailsFormChange,
        isRequired: shiftDetailsForm.siteContactName.required,
        size: 6,
        type: 'textfield',
        disabled: currentRecord
          ? currentRecord.shiftStatusId > 0
            ? true
            : false
          : false,
        inputType: 'text',
        validationRules: [(value) => (!value ? 'Name is required' : '')],
      },
      {
        name: 'siteContactNumber',
        label: 'Phone Number',
        value: shiftDetailsForm.siteContactNumber.value,
        onChange: handleshiftDetailsFormChange,
        isRequired: shiftDetailsForm.siteContactNumber.required,
        size: 6,
        type: 'textfield',
        disabled: currentRecord
          ? currentRecord.shiftStatusId > 0
            ? true
            : false
          : false,
        inputType: 'tel',
        validationRules: [
          (value) => (!value ? 'Contact Number is required' : ''),
          (value) =>
            !phoneRegex.test(value) ? 'Invalid Australian Contact Number' : '',
        ],
      },
    ];

    useEffect(() => {
      console.log('->>>>-Details--->>>');
      if (currentRecord) {
        handleRowClick(currentRecord);
      }
    }, [currentRecord]);

    const fetchQuoteDetails = async (quoteId: any) => {
      try {
        setLoading(true);
        const response = await HttpService.get(
          Constants.apiURL + Constants.quoteURL + '/' + quoteId,
          { headers: { Authorization: 'Bearer ' + getAdmin() } }
        );
        setLoading(false);
        if (response.success) {
          setQuoteDetails(response.data);
          setSiteAddress(response.data.projectSiteAddress);
          setShiftDetailsForm((prev) => ({
            ...prev,
            ['siteContactName']: {
              required: prev['siteContactName'].required,
              value: response.data.customerMainContact,
            },
            ['siteContactNumber']: {
              required: prev['siteContactNumber'].required,
              value: response.data.customerContactNumber,
            },
          }));
        }

        console.log('GET Response:', response);
      } catch (error: any) {
        console.error(`PATCH Error:`, error);
        setHttpError({
          errorColor: 'error',
          message: handleErrorMessage(error),
          open: true,
        });
      }
    };
    return (
      <Stack>
        <Box sx={{ width: '70%', margin: '0 auto', position: 'relative' }}>
          {loading && (
            <Box
              sx={{
                width: '100%',
                textAlign: 'center',
                position: 'absolute',
                top: '25%',
                zIndex: 113,
              }}
            >
              <CircularProgress />
            </Box>
          )}
          <CommonForm
            elevationPaper={0}
            fields={formFields}
            onCancel={() => {}}
            singlePage={true}
            formReset={clearForm}
            formTitle={''}
            isLoading={loading}
            isUpdate={false}
            onSave={() => {}}
            actionButtonPosition="bottom"
            isHideAction={true}
          />
        </Box>

        <Divider />
        {
          <ShiftSaveButtons
            processing={processing}
            publishing={publishing}
            handleSave={handleSave}
            shiftStatus={currentRecord ? currentRecord.shiftStatusId : 0}
          />
        }
        <AlertMessageComponent
          type={httpError.errorColor}
          open={httpError.open}
          handleClose={handleCloseAlert}
          message={httpError.message}
        />
        {isChoosing && <GoogleMapModal />}
      </Stack>
    );
  }
);

export default ShiftDetailsForm;
